import { render, staticRenderFns } from "./NotificationsPager.vue?vue&type=template&id=af1dd5fc&"
import script from "./NotificationsPager.vue?vue&type=script&lang=js&"
export * from "./NotificationsPager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports